import React from "react";
import { Posts } from "../components/posts/Posts";

export const SearchPage = () => {

  return (
    <>
      <Posts />
    </>
  );
};
